export default `
  query(
    $dateStart: DateTime!
    $dateEnd: DateTime!
    $storeIDs: [Int]
    $productIDs: [Int]
  ){
    Sale{
      Week(
        dateGroupType: MONTH
        dateStart: $dateStart
        dateEnd: $dateEnd
        storeIDs: $storeIDs
        productIDs: $productIDs
      ){
        Date
        Quantity
      }
    }
    Prediction{
      Sale(
        dateGroupType: MONTH
        dateStart: $dateStart
        dateEnd: $dateEnd
        storeIDs: $storeIDs
        productIDs: $productIDs
      ){
        Date
        Quantity
      }
    }
  }
`;
